export default {"src":"/_next/static/media/logo-CCA-green-mobile.932d13ee.svg","height":34,"width":121,"blurWidth":0,"blurHeight":0};